import { IconType } from "react-icons";
import { MdOutlineSettings, MdOutlineStorefront } from "react-icons/md";
import { GrTransaction } from "react-icons/gr";
import { TfiLayoutSliderAlt } from "react-icons/tfi";
import { LuDot } from "react-icons/lu";

import {
  TbUsers,
  TbTruckDelivery,
  TbSmartHome,
  TbCategory,
  TbActivity,
} from "react-icons/tb";
import { TbPlugConnected } from "react-icons/tb";
import { LiaCitySolid } from "react-icons/lia";
import { BsBoxSeam, BsCreditCard2Front } from "react-icons/bs";
import { FaRegBell } from "react-icons/fa";
import { RiMapLine, RiCalendarScheduleLine } from "react-icons/ri";
import { PiInvoice, PiStack } from "react-icons/pi";
import { GrMoney } from "react-icons/gr";
import { FaRegChartBar } from "react-icons/fa";

interface Link {
  title: string;
  icon: IconType;
  path: string;
  allowedTo: string[];
  children?: Link[];
}

export const links: Link[] = [
  {
    title: "الرئيسية",
    icon: TbSmartHome,
    path: "/",
    allowedTo: ["admin"],
  },
  {
    title: "احصائيات الفواتير",
    icon: FaRegChartBar,
    path: "/orders/statistics",
    allowedTo: ["admin", "accountant"],
  },
  {
    title: "الفواتير",
    icon: TbTruckDelivery,
    path: "/orders",
    allowedTo: ["admin", "accountant"],
  },
  {
    title: "الفواتير النشطة",
    icon: TbActivity,
    path: "/orders/active-orders",
    allowedTo: ["admin", "accountant"],
  },
  {
    title: "فواتير المجدولة",
    icon: RiCalendarScheduleLine,
    path: "/scheduled-orders",
    allowedTo: ["admin", "accountant"],
  },
  {
    title: "التصنيفات",
    icon: TbCategory,
    path: "/categories?parent_key=item",
    allowedTo: ["admin"],
    children: [
      {
        title: "تصنيفات المنتجات",
        icon: TbCategory,
        path: "/categories?parent_key=item",
        allowedTo: ["admin"],
      },
      {
        title: "تصنيفات الانشطة التجارية",
        icon: TbCategory,
        path: "/categories?parent_key=business",
        allowedTo: ["admin"],
      },
      {
        title: "تصنيفات الفئات المستهدفة",
        icon: TbCategory,
        path: "/categories?parent_key=user_class",
        allowedTo: ["admin"],
      },
    ],
  },
  {
    title: "الانشطة التجارية",
    icon: MdOutlineStorefront,
    path: "/businesses",
    allowedTo: ["admin"],
  },
  {
    title: "المدن",
    icon: LiaCitySolid,
    path: "/cities",
    allowedTo: ["admin"],
  },
  {
    title: "المناطق",
    icon: RiMapLine,
    path: "/areas",
    allowedTo: ["admin"],
  },
  {
    title: "الوحدات",
    icon: PiStack,
    path: "/units",
    allowedTo: ["admin"],
  },
  {
    title: "المستخدمين",
    icon: TbUsers,
    path: "/users",
    allowedTo: ["admin"],
    children: [
      {
        title: "الزبائن",
        icon: TbUsers,
        path: "/users?type=customer",
        allowedTo: ["admin"],
      },
      {
        title: "المسؤولين",
        icon: TbUsers,
        path: "/users?type=account-manager",
        allowedTo: ["admin"],
      },
      {
        title: "السائقين",
        icon: TbUsers,
        path: "/users?type=driver",
        allowedTo: ["admin"],
      },
      {
        title: "المحاسبين",
        icon: TbUsers,
        path: "/users?type=accountant",
        allowedTo: ["admin"],
      },
      {
        title: "مستخدمين نقاط البيع",
        icon: TbUsers,
        path: "/users?type=point-of-sale",
        allowedTo: ["admin"],
      },
      {
        title: "مجموعات الحسابات",
        icon: TbPlugConnected,
        path: "/linked-accounts",
        allowedTo: ["admin"],
      },
    ],
  },
  // {
  //   title: "التسوية المالية",
  //   icon: GrMoney,
  //   path: "/settlements",
  //   allowedTo: ["admin", "accountant"],
  // },
  {
    title: "متابعة الحركة المالية",
    icon: GrTransaction,
    path: "/transactions",
    allowedTo: ["admin", "accountant"],
  },
  {
    title: "ارسال اشعار",
    icon: FaRegBell,
    path: "/push-notifications",
    allowedTo: ["admin"],
  },
  {
    title: "البانرز",
    icon: TfiLayoutSliderAlt,
    path: "/banners",
    allowedTo: ["admin"],
  },
  {
    title: "قوائم الأسعار",
    icon: BsCreditCard2Front,
    path: "/pricelists",
    allowedTo: ["admin"],
  },
  {
    title: "سندات مسؤولين",
    icon: GrMoney,
    path: "/admin-settlements",
    allowedTo: ["admin", "accountant", "account-manager"],
  },
  {
    title: "الضبط",
    icon: MdOutlineSettings,
    path: "/settings",
    allowedTo: ["admin"],
  },
  {
    title: "سجلات النظام",
    icon: TbActivity,
    path: "/activity-logs",
    allowedTo: ["admin"],
  },
];
